/* index.js */

"use strict";
const Registrations = require("./src/app/Registrations"),
    Steve = require("@gluenetworks/steve_core").getInstance(),
    RoboHelpComponent = require("./src/app/sections/robohelpcomponent/RoboHelpComponent");

Steve.di.registry.register(Registrations.ROBO_HELP_SECTION, RoboHelpComponent);
